import React, { Component } from "react";
import { Card, Grid, Button } from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Alert from '@material-ui/lab/Alert';
import jwtAuthService from "app/services/jwtAuthService";
import UserService from "app/services/UserService";
import Snackbar from '@material-ui/core/Snackbar';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { resetPassword } from "../../redux/actions/LoginActions";
import * as appconst from '../../appconst';

class ResetPassword extends Component {
  state = {
    email: "",
    message: false,
    messageText: "",
    severity: "error",
    open_sent: false,
    same_password_error: false,
    formdata: {password:"", confirm_password:""},
    user_id:0,
  };

  handleChange = event => {
    event.persist();
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  componentDidMount() {

    this.getURLdata();

  }

  getURLdata() {
    const query = new URLSearchParams(this.props.location.search);
    const urldata = query.get('pw_rs')
    var user_id = urldata.replace('kj356df74as890d', '').replace('k2sd8df253d9dd', '');

    this.setState({ user_id: user_id });

  }

  handleFormSubmit = async () => {
    this.setState({ disable_submit_button: true });

    var formdata = this.state.formdata;
    var user_id = this.state.user_id;

    if(!this.state.same_password_error){
      UserService.resetPassword(formdata,user_id).then((res) => {
        if (res.status == 200) {
          this.setState({ message: res.data.message, snakebar: true, severity: "success", submit_disable: true })
          setTimeout(() => {
            this.props.history.push("/session/signin");
        }, 1000);
        } else {
            this.setState({ message: "Can not update user", snakebar: true, severity: "error", submit_disable: false })
        }
      })
    }else{
      this.setState({ disable_submit_button: false });
    }

  };

  handleOpenSent = () => {//For handle edit dialog
    this.setState({ open_sent: true })
  }

  handleCloseSent = () => {//For handle edit dialog
    this.setState({ open_sent: false })
  }

  handleChange = event => {
    event.persist();
    var data = this.state.formdata;

    data[event.target.name] = event.target.value;

    this.setState({
        formdata: data
    });

    if (event.target.name == "confirm_password") {
        if (event.target.value != data.password) {
            this.setState({
                same_password_error: true
            });
        } else {
            this.setState({
                same_password_error: false,
            });
        }
    } else if (event.target.name == "password") {
        if (event.target.value != data.confirm_password) {
            this.setState({
                same_password_error: true
            });
        } else {
            this.setState({
                same_password_error: false,
            });
        }
    }
};
  render() {
    let { email } = this.state;

    return (
      <div className="signup flex justify-center w-full h-full-screen"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: 'url("/assets/images/sign_up_bg.jpg")',
          width: "100%",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <div className="p-8">
          <Card className="signup-card position-relative y-center">
            <Grid container>
              {/* <Grid item lg={5} md={5} sm={5} xs={12}>
                <div className="p-8 flex justify-center items-center h-full">
                  <img src="/assets/images/illustrations/dreamer.svg" alt="" />
                </div>
              </Grid> */}
              <Grid item >
                <div className="p-9 h-full bg-white position-relative">
                  <ValidatorForm ref="form" onSubmit={this.handleFormSubmit}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={12}>
                        <TextValidator
                          className="mb-5 w-full"
                          label="New Password *"
                          variant="outlined"
                          onChange={this.handleChange}
                          name="password"
                          type="password"
                          onCopy={(e) => {
                            e.preventDefault()
                            return false;
                          }}
                          size="small"
                          value={this.state.formdata.password}
                          validators={["required"]}
                          errorMessages={["this field is required"]}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <TextValidator
                          className="mb-6 w-full"
                          label="Confirm New Password *"
                          variant="outlined"
                          onChange={this.handleChange}
                          name="confirm_password"
                          type="password"
                          onPaste={(e) => {
                            e.preventDefault()
                            return false;
                          }}
                          onCopy={(e) => {
                            e.preventDefault()
                            return false;
                          }}
                          size="small"
                          value={this.state.formdata.confirm_password}
                          validators={["required"]}
                          errorMessages={["this field is required"]}
                        />
                        {this.state.same_password_error ?
                          <p style={{ color: "red", fontSize: 11.5 }} className="mt--5 ml-5">password doesnt match</p>
                          : ""
                        }
                      </Grid>
                    </Grid>
                    <div className="flex items-center">
                      <Grid container spacing={2} align="center">
                        <Grid item md={12} sm={12} xs={12}>
                          <Button variant="contained" color="primary" type="submit" disabled={this.state.disable_submit_button}>
                            Reset Password
                          </Button>
                        </Grid>
                        <Grid item md={12} sm={12} xs={12}>
                          <Button
                            className="text-primary"
                            onClick={() =>
                              this.props.history.push("/session/signin")
                            }
                          >
                            Login to your Account
                          </Button>
                        </Grid>
                      </Grid>
                    </div>
                  </ValidatorForm>
                  <Dialog fullWidth={true} maxWidth="xs" onClose={() => { this.handleCloseSent(); }} aria-labelledby="customized-dialog-title" open={this.state.open_sent}>
                    <Typography style={{ color: "darkgreen" }} className="pl-5 pt-5 pr-5 pb-5">
                      Please check your email for the password reset link
                    </Typography>
                  </Dialog>
                </div>
              </Grid>
            </Grid>
          </Card>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }} open={this.state.snakebar} autoHideDuration={2500} onClose={this.handleClose}>
            <Alert onClose={this.handleClose} severity={this.state.severity}>
              {this.state.message}
            </Alert>
          </Snackbar>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  resetPassword: PropTypes.func.isRequired,
  login: state.login
});
export default withRouter(
  connect(mapStateToProps, { resetPassword })(ResetPassword)
);
